<template>
  <div>
    <v-row row wrap class="mt-10 ">
        <v-flex sm3 xs12 class="mx-0">
            
            
       

    <vCardContainer class="mx-4">
        <template #content>
            <DatePickerWithMenu 
            class="mx-2"
            label="Select Date From"
            @date-selected="getDateFrom">
            </DatePickerWithMenu>
        </template>
    </vCardContainer>

<vCardContainer class="mx-4 mt-2">
        <template #content>
            <DatePickerWithMenu 
            class="mx-2"
            label="Select Date To"
            @date-selected="getDateTo">
            </DatePickerWithMenu>

            <vButton 
            class="ml-4"
            :color="getThemeColor" 
            label="Expense Receipts" 
            icon="mdi-printer"
            @button-clicked="getExpensesReceipts">
            </vButton>
        </template>
</vCardContainer>
        </v-flex>
        <v-flex sm9 xs12>
            <TableComponent 
            :headers="headers" 
            :items="expenses" 
            :itemsPerPage="50" 
            table="expenses" 
            title="Expenses"
            @items-selected="getSelectedExpenses"
            @item-deleted="getAllExpenses">
            </TableComponent>
        </v-flex>
        
    </v-row>
  </div>
</template>

<script>
import axios from "@/plugins/axios"
import TableComponent from '@/components/GeneralComponents/TableComponent.vue'
import vButton from '@/components/Legos/vButton.vue'
import DatePickerWithMenu from '@/components/myLibrary/DatePickerWithMenu.vue'
import vCardContainer from '@/components/Legos/vCardContainer.vue'
export default {
    components:{
        TableComponent,
        vButton,
        DatePickerWithMenu,
        vCardContainer
    },
    computed:{
        isMobile(){
            return this.$store.getters.isMobile
        },
        isManager(){
            return this.$store.getters.isManager
        },
        getAccessToken(){
            return this.$store.getters.getAccessToken
        },
         getThemeColor(){
            return this.$store.getters.getThemeColor
        }
    },
    mounted(){
        this.getAllExpenses()
    },
    data:() => ({
        expenses:[],
        selectedExpenses:[],
        dateFrom:null,
        dateTo:null,
        headers:[
            {
                text: "Select",
                value: 'selection'
            },
            {
                text: "Date",
                value:'entry_date'
            },
            {
                text: "Description",
                value:'description'
            },
            {
                text: "Amount",
                value:'amount'
            }
            
        ]
    }),
    methods:{
         getAllExpenses(){
        this.$store.commit('setLoader',true)
        axios.getData("/auth/get-all-expenses",this.getAccessToken)
        .then(response => {
            this.expenses = response.expenses
            this.totalExpenses = response.totalExp
             this.$store.commit('setLoader',false)
        })
    },
    getSelectedExpenses(selectedExpenses){
        this.selectedExpenses = selectedExpenses
    },
    getDateFrom(dateFrom){
        this.dateFrom = dateFrom
    },
    getDateTo(dateTo){
        this.dateTo = dateTo
       this.expenses = this.expenses.filter(expense => {
            return expense.entry_date >= this.dateFrom && expense.entry_date <= this.dateTo 
        })
    },
    getExpensesReceipts(){
        this.$router.push({
            name: "finance-expense-receipts",
            params:{
                expenses:this.selectedExpenses
            }
        }).catch(() => true);
    }
    }
   
}
</script>

<style>

</style>